import state from './moduleFormationState'
import mutations from './moduleFormationMutations'
import actions from './moduleFormationActions'
import getters from './moduleFormationGetters'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}